<template>
    <div>
        <header class="header">
            <slot name="header"></slot>
            <div class="body-1 grey-darken-2">
                <slot name="subheader"></slot>
            </div>
        </header>
        <section class="body-large-1">
            <slot name="main"></slot>
        </section>
    </div>
</template>

<script>
    export default {
        name: "PageHeader",
    }
</script>

<style lang="scss" scoped>
    header {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-height: 60px;
    }

    p {
        max-width: to_rem(468);
    }

    h1 {
        font-weight: 600 !important;
        font-size: to_rem(38px) !important;
        line-height: to_rem(28px);
        letter-spacing: -0.5px;
        color: $primary-color;
    }

    h4 {
        font-weight: 600 !important;
        font-size: to_rem(22px) !important;
        line-height: to_rem(28px) !important;

        color: #002855;
    }
    .body-large-1 {
        font-size: 18px;
        line-height: 28px;
        font-weight: bold;
        color: #002855;
    }

    #payment-options-message {
        .header-text-container {
            div {
                .header {
                    padding-top: 0px !important;

                    max-width: 484px;
                }
            }
        }
    }
</style>
